import React, { useEffect } from "react";
import { Badge, Nav } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { BsHouseDoor, BsKanban, BsPeople } from "react-icons/bs";
import { FaFolderOpen } from "react-icons/fa6";
import { FaTasks } from "react-icons/fa";
import { TbPackages } from "react-icons/tb";
import { SiGooglemeet } from "react-icons/si";
import { IoMdNotifications } from "react-icons/io";
import { fetchUnreadNotifications } from "../store/features/notification/notificationSlice";

function Sidebar({ show, isMobile, setShowSidebar }) {
  const { role } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const { unreadCount } = useSelector((state) => state.notifications);

  useEffect(() => {
    dispatch(fetchUnreadNotifications());
  }, [dispatch]);

  return (
    <div
      className="sidebar"
      style={{
        width: show && !isMobile ? "18%" : show && isMobile ? "100%" : 0,
      }}
    >
      <Nav className="flex-column px-2 mt-3">
        <Nav.Link
          as={NavLink}
          to="/dashboard"
          activeClassName="active"
           onClick={() =>
                isMobile ? setShowSidebar(false) : setShowSidebar(true)
              }
        >
          <BsHouseDoor className="me-2" /> Dashboard
        </Nav.Link>
        {(role === "manager" ||
          role === "assistant superadmin" ||
          role === "superadmin" ||
          role === "staff" ||
          role === "auditor") && (
          <>
            <Nav.Link
              as={NavLink}
              to="/user-management"
              activeClassName="active"
              onClick={() =>
                isMobile ? setShowSidebar(false) : setShowSidebar(true)
              }
            >
              <BsPeople className="me-2" /> Users
            </Nav.Link>
            {(role === "superadmin" || role === "assistant superadmin") && (
              <Nav.Link
                as={NavLink}
                to="/resource-allocation"
                activeClassName="active"
                onClick={() =>
                  isMobile ? setShowSidebar(false) : setShowSidebar(true)
                }
              >
                <BsPeople className="me-2" /> Resource Allocation
              </Nav.Link>
            )}

            <Nav.Link
              as={NavLink}
              to="/project-management"
              activeClassName="active"
              onClick={() =>
                  isMobile ? setShowSidebar(false) : setShowSidebar(true)
                }
            >
              {role === "manager" ? (
                <TbPackages className="me-2" />
              ) : role === "staff" ? (
                <FaTasks className="me-2" />
              ) : (
                <FaFolderOpen className="me-2" />
              )}
              {role === "manager"
                ? "Work Packages"
                : role === "staff"
                ? "Tasks"
                : "Projects"}
            </Nav.Link>
            <Nav.Link
              as={NavLink}
              to="/meeting"
              activeClassName="active"
              onClick={() =>
                  isMobile ? setShowSidebar(false) : setShowSidebar(true)
                }
            >
              <SiGooglemeet className="me-2" /> Meetings
            </Nav.Link>

            <Nav.Link
              as={NavLink}
              to="/notifications"
              activeClassName="active"
              onClick={() =>
                  isMobile ? setShowSidebar(false) : setShowSidebar(true)
                }
            >
              <span className="notification-count">
                <IoMdNotifications className="me-2" />
                <Badge bg="danger">{unreadCount}</Badge>
                Notifications
              </span>
            </Nav.Link>
          </>
        )}
      </Nav>
    </div>
  );
}

export default Sidebar;
